import React, { PureComponent, Fragment } from 'react';
import T from 'prop-types';
// shapes
import inputStep from '../../../shapes/inputStep';
// components
import Input from '../../../components/Input/Input';
import TextArea from '../../../components/TextArea/TextArea';
import FieldError from '../../../components/Form/FieldError';
// utils
import mathjs from 'mathjs';
// styles
import styles from './TextInputsSet.mod.css';
import classnames from 'classnames/bind';

const cn = classnames.bind(styles);

class TextInputsSet extends PureComponent {
  getValueByWeight = weight => {
    const {
      values,
      data: { content }
    } = this.props;
    const item = content.questions.find(item => item.weight === weight);

    if (!item) {
      return 1;
    }

    return Number(values[item.id]);
  };

  getFormulaAnswer = (formula, units) => {
    if (!formula) {
      return '';
    }

    const formulaWithValues = formula.replace(
      /#\d/gi,
      x => `${this.getValueByWeight(parseInt(x.substring(1), 10))}`
    );

    const answer = Math.round(+mathjs.eval(formulaWithValues));

    return !isNaN(answer)
      ? `${answer} ${units ? units : ''}`
      : 'Please, provide the right values (number) in the previous questions';
  };

  render() {
    const {
      data: { content },
      values,
      errors,
      setFieldValue
    } = this.props;

    return content.questions.map(item => {
      const {
        title,
        id,
        question_type,
        additional_info,
        placeholder,
        units = ''
      } = item;

      const inputProp = {
        name: id,
        rows: 3,
        type: question_type,
        className: cn('input'),
        placeholder: placeholder || 'Please, type here',
        value: values[id],
        invalid: !!errors[id],
        onChange: e => setFieldValue(id, e.target.value),
        autoComplete: 'none'
      };

      const inputTypes = ['text', 'number'];
      return (
        <div className={cn('container')} key={id}>
          <label className={cn('label')} htmlFor={id}>
            {title}
          </label>
          {inputTypes.includes(question_type) && (
            <Fragment>
              {question_type === 'text' && <TextArea {...inputProp} />}
              {question_type === 'number' && (
                <Input wrapperClassName={cn('input-wrapper')} {...inputProp} />
              )}
              <FieldError error={errors[id]} touched={true} />
            </Fragment>
          )}
          {question_type === 'formula' && (
            <div>{`${this.getFormulaAnswer(additional_info, units)}`}</div>
          )}
        </div>
      );
    });
  }
}

TextInputsSet.propTypes = {
  data: inputStep,
  values: T.object.isRequired,
  setFieldValue: T.func.isRequired
};

export default TextInputsSet;



// WEBPACK FOOTER //
// ./src/containers/Module/components/TextInputsSet.jsx